import React, { memo } from "react";

const Ranking = memo(() => {
  return <div>Ranking</div>;
});

export default Ranking;
